import React from 'react';
import { RefreshCw, Zap, CheckCircle2, Info } from 'lucide-react';

const ModernizationWizard = ({ data = {}, setData }) => {
  
  const handleToggle = (option) => {
    setData({
      ...data,
      modernOptions: { ...data.modernOptions, [option]: !data.modernOptions[option] }
    });
  };

  return (
    <div className="animate-in fade-in slide-in-from-top-4 duration-500 text-left">
      
      {/* NOTA DE USO PROFESIONAL */}
      <div className="bg-emerald-900/10 border-l-4 border-emerald-600 p-6 mb-10 rounded-r-3xl flex gap-4 items-start shadow-sm">
        <div className="bg-emerald-600 p-2 rounded-xl text-white shadow-lg shadow-emerald-500/20 shrink-0">
            <RefreshCw size={20}/>
        </div>
        <div>
            <p className="text-[11px] text-emerald-800 font-black uppercase tracking-widest mb-1 italic">Guía de Modernización:</p>
            <p className="text-[11px] text-slate-600 leading-relaxed font-medium">
                Esta herramienta actúa como un **Refactoring Engine**. Está diseñada para migrar lógica de versiones 6.0 o inferiores hacia la sintaxis **7.40/7.50+**. 
                Pegue su código antiguo (con sentencias como `READ TABLE`, `LOOP AT` con `WORK AREA` o declaraciones de datos previas) y el sistema lo reescribirá 
                utilizando expresiones de tabla e inferencia de tipos para optimizar la legibilidad y el uso de memoria.
            </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-10">
        
        {/* COLUMNA 1: CONFIGURACIÓN DE SINTAXIS */}
        <div className="bg-[#0F172A] p-8 rounded-[32px] text-white shadow-xl italic border-b-4 border-emerald-500">
          <label className="text-[10px] font-black text-emerald-400 uppercase block mb-6 border-b border-slate-800 pb-2 flex items-center gap-2">
            <Zap size={14}/> Syntax Optimization Rules
          </label>
          
          <div className="space-y-4 bg-slate-800/50 p-6 rounded-2xl border border-white/5">
            <label className="flex items-center justify-between group cursor-pointer">
                <span className="text-[10px] font-bold uppercase tracking-wider group-hover:text-emerald-400 transition-colors">Inline Declarations (DATA/FIELD-SYMBOL)</span>
                <input type="checkbox" className="w-4 h-4 rounded border-none bg-slate-700 text-emerald-500 focus:ring-0" 
                    checked={data.modernOptions?.inline || false} onChange={() => handleToggle('inline')} />
            </label>
            
            <label className="flex items-center justify-between group cursor-pointer">
                <span className="text-[10px] font-bold uppercase tracking-wider group-hover:text-emerald-400 transition-colors">Constructor Operators (VALUE/NEW)</span>
                <input type="checkbox" className="w-4 h-4 rounded border-none bg-slate-700 text-emerald-500 focus:ring-0" 
                    checked={data.modernOptions?.constructors || false} onChange={() => handleToggle('constructors')} />
            </label>

            <label className="flex items-center justify-between group cursor-pointer">
                <span className="text-[10px] font-bold uppercase tracking-wider group-hover:text-emerald-400 transition-colors">Table Expressions ( itab[ ... ] )</span>
                <input type="checkbox" className="w-4 h-4 rounded border-none bg-slate-700 text-emerald-500 focus:ring-0" 
                    checked={data.modernOptions?.tableExp || false} onChange={() => handleToggle('tableExp')} />
            </label>

            <label className="flex items-center justify-between group cursor-pointer">
                <span className="text-[10px] font-bold uppercase tracking-wider group-hover:text-emerald-400 transition-colors">String Expressions ( |...| )</span>
                <input type="checkbox" className="w-4 h-4 rounded border-none bg-slate-700 text-emerald-500 focus:ring-0" 
                    checked={data.modernOptions?.strings || false} onChange={() => handleToggle('strings')} />
            </label>
          </div>
        </div>

        {/* COLUMNA 2: BENEFICIOS TÉCNICOS */}
        <div className="bg-[#0F172A] p-8 rounded-[32px] text-white shadow-xl italic border-b-4 border-emerald-500">
            <label className="text-[10px] font-black text-emerald-400 uppercase block mb-6 border-b border-slate-800 pb-2 flex items-center gap-2">Impacto en el Código</label>
            <ul className="space-y-4">
                <li className="flex items-start gap-3 text-[10px] font-bold text-slate-500">
                    <CheckCircle2 size={14} className="text-emerald-500 shrink-0"/> Reducción de líneas de código hasta un 40%.
                </li>
                <li className="flex items-start gap-3 text-[10px] font-bold text-slate-500">
                    <CheckCircle2 size={14} className="text-emerald-500 shrink-0"/> Eliminación de variables auxiliares innecesarias.
                </li>
                <li className="flex items-start gap-3 text-[10px] font-bold text-slate-500">
                    <CheckCircle2 size={14} className="text-emerald-500 shrink-0"/> Preparación automática para S/4HANA Readiness.
                </li>
            </ul>
        </div>

      </div>
    </div>
  );
};

export default ModernizationWizard;